import axios from 'axios'

import { ASSET_API_V2_URL, REACT_APP_PRICE_API_URL_TESTNET } from '@src/configs/env'
import { isFeatureEnabled } from '@src/utils'

// MachProtocol API instance
export const assetApiV2 = axios.create({
    baseURL: isFeatureEnabled('USE_TESTNETS_ONLY') ? REACT_APP_PRICE_API_URL_TESTNET : ASSET_API_V2_URL,
})
